const compareIr2Jcamp = `
##TITLE=Comparison 2
##JCAMP-DX=5.0
##DATA TYPE=LINK
##BLOCKS=1


$$ === CHEMSPECTRA SPECTRUM ORIG ===
##TITLE=Comparison 2
##JCAMP-DX=5.00
##DATA TYPE=INFRARED SPECTRUM
##DATA CLASS=XYDATA
##$CSCATEGORY=SPECTRUM
##ORIGIN=Default
##OWNER=
##XUNITS=1/CM
##YUNITS=TRANSMITTANCE
##XFACTOR=1.0
##YFACTOR=9.7592101e-10
##FIRSTX=3996.5625
##LASTX=399.65625
##MAXX=3996.5625
##MAXY=1.0478872043814014
##MINX=399.65625
##MINY=0.49353858745198814
##NPOINTS=1765
##XYDATA= (X++(Y..Y))
1765I41543228I41716560I41251289I40645055I40250753I39896761I39741325I40256556
1757I41062994I41349620I41327022I41524478I41547687I40926796I40051709I39617953
1749I40098859I40997948I41262221I41222828I41711185I42521777I43475711I44434288
1741I44772950I44530665I43906842I42507729I41074659I40828831I41585554I42509378
1733I43322473I43851813I44095992I44184307I43592426I43249488I44132393I44400391
1725I42940936I41586531I41401656I42333237I45434212I50047167I52440951I51530258
1717I48651719I45375946I44762751I47032247I47722153I46875589I48582643I49989756
1709I49643032I49178676I47160993I46675567I49121876I52545084I54967879I53141118
1701I50915168I51345810I50617182I48721589I49606753I55295609I62531564I59310209
1693I50109158I45867969I46751178I50031531I53379678I56468865I57277380I54332330
1685I51459960I49646818I48388912I48556625I49205671I51688259I56360335I57199326
1677I55481950I52256443I46715999I43965107I46099688I49763961I50835832I52643171
1669I53963863I51332618I49008398I46807001I44364295I43100037I42858912I43616001
1661I44469162I44967963I46611011I47073411I44510082I43073653I45252452I48990259
1653I50189594I48919839I47082634I46920601I49329776I50512621I50694076I54783432
1645I61983718I63605206I59809683I59344106I58669774I53859852I51612282I54703790
1637I59899403I59837106I53411559I47507840I45883543I47019604I48056235I47586138
1629I46031406I45317986I47288824I52203307I55454161I51760939I46379474I44798480
1621I46441282I47130089I45654205I44485835I44966803I48708763I54855440I56343234
1613I50278825I44826696I43776018I46329331I51534411I57671865I58896913I57153458
1605I57479173I53731838I47148839I43716165I42634949I42936172I45520634I48054769
1597I48997160I53369539I60908122I60824876I51962670I45278043I43554315I43750978
1589I43687581I44108146I45581404I48815523I53688902I53288370I47704197I45639914
1581I48646833I52758970I53056529I52123848I52486819I52243800I50905702I48403570
1573I45797427I45346142I46137738I45936984I45472201I45577556I45307970I45859601
1565I48462019I49513857I47060463I45090542I44522541I44037787I43425019I42976360
1557I42931897I44604382I48773991I51040861I48097888I44802083I43510280I42980940
1549I43202522I44375533I44501409I43189879I42944906I43604030I43237334I42241258
1541I41631238I41499437I41964831I42980024I44194934I45426333I46170902I45760293
1533I44474475I43249488I42323832I41956830I42430652I42926645I42887495I42538694
1525I42511760I43549429I44605482I44125552I43279415I43347820I43610382I43171007
1517I42459480I42357912I42628048I43003233I43151157I42165341I40911649I40977000
1509I41644369I41611938I41224049I40941820I40838969I41317189I41730058I41147400
1501I40412603I40395624I40651529I40797744I41195771I42237044I43333039I43260360
1493I42184397I41437629I41395671I41528815I41561673I41508110I41375516I41346994
1485I41725538I42264894I42410009I42161799I41819472I41683518I42013203I42503210
1477I42704086I42572225I42351926I42323160I42662066I43136011I42896534I42093089
1469I41901435I42025601I41828084I41852514I42197345I42616688I42851094I42597510
1461I42140056I41805608I41955914I42782079I43495133I43405291I42855919I42164608
1453I41421505I41034716I41189236I41505484I41871813I42392419I42581997I42422285
1445I42590120I42939165I42843765I42747083I42888289I42665853I42268681I41846589
1437I41494918I41715644I42025357I41928003I41869187I41775986I41646262I42047710
1429I42839857I43470214I43433142I42922186I42825504I43360645I43909101I43736564
1421I42966710I42632567I42952174I43100587I42648874I42075377I42133582I42507180
1413I42539611I42518417I42556101I42246571I41874134I41873340I42154775I42777987
1405I43316488I43286256I43077989I42992850I42484032I41505056I41554466I42831428
1397I43854867I44328017I44490233I43927913I42970558I42966527I44011403I44604016
1389I44341514I43989904I43370417I42521654I42381731I42660723I42554574I42220309
1381I42064567I42203513I42288652I42171998I42041969I41882013I41849460I41999827
1373I42060536I42111473I42198383I42479268I43092525I43248572I42937149I42836070
1365I42910582I43041894I43022960I42650218I42353331I42645637I42689611I41900336
1357I41366904I41552145I41682969I41552023I41579690I41924033I42315159I42164486
1349I42017112I42428698I42468763I41969412I41580362I41333923I41242982I41680098
1341I42064933I41652736I41491131I42151721I42683076I42899710I42927133I42490323
1333I41611755I40397945I39355390I39033890I39077620I39123060I39415977I39776138
1325I39764839I39194212I37788870I35818643I33685222I31615809I30302507I29743180
1317I29645704I30090576I30044770I28605836I26667246I25439877I24723220I23294547
1309I20818128I17733582I14285822I12007775I12523494I14258643I15121331I15741612
1301I17426190I20117655I22714210I24351455I24981263I24610475I23485835I22488842
1293I21576866I20011812I17874788I16068731I15521985I15906088I16848479I18785115
1285I20783254I21900687I22889984I23973276I24828880I25563249I26080496I26494647
1277I27386896I28586414I29476220I30180173I30779688I30843023I30538869I30937079
1269I31942378I32656837I33310220I33704705I33168465I31754511I29437559I27082802
1261I26756721I28450277I30230377I31198237I31402229I30967495I30504727I30589378
1253I30757396I30694733I30436079I29847557I29136153I28667705I28491198I28231139
1245I27524620I26207532I24518923I22669014I20770794I19567245I19536585I20434514
1237I21998224I23896810I25769012I27054952I27422991I27858580I29049792I30173394
1229I30588828I31087263I32197490I32934729I33230212I33997806I35071570I35791587
1221I36094703I36460605I37019932I37258309I36864679I36166650I35801664I36002846
1213I36269195I36244887I36255942I36402095I36189370I35436006I34355890I33166022
1205I32085233I31416948I31347994I31784010I32873104I34453672I35711395I36377726
1197I36909142I37286831I37345342I37624761I38256524I38706771I38789833I38882179
1189I39253272I39651605I39767892I39822372I40075651I40191266I39899937I39527134
1181I39584483I39929803I40117182I39856024I39142482I38461675I38029568I38039279
1173I38683257I39443399I39734545I39678173I39684280I40009201I40349207I40239393
1165I40246051I40687808I41039235I41255136I41446730I41410145I41225271I41115396
1157I41082354I41096707I41007843I40860285I40750899I40847459I41197237I41158027
1149I40713093I40502933I40643895I40920077I41154790I41157477I41003567I40982619
1141I41079667I41382784I41633925I41465174I41385288I41496201I41353773I41249090
1133I41647973I42017783I41741051I41266985I41182335I41402389I41607296I41680342
1125I41481481I41196504I41254587I41351574I41159554I41025799I41123947I41257824
1117I41381318I41566559I41938447I42424911I42578393I42290973I41960922I41867294
1109I41998361I42254084I42549932I42931775I43324611I43467955I43412376I43284301
1101I43059422I42836009I42780125I42847063I42837597I42926767I43341285I43779439
1093I44080356I44082800I43406757I42814144I43195803I43746458I43607512I43295295
1085I43462763I43826955I43877159I43772171I43746947I43640187I43441876I43556086
1077I44218936I44483331I43906536I43738213I44100695I44214111I44217470I44109917
1069I43890412I43609955I43198674I43216935I43458671I43648493I44161709I44454565
1061I44486690I44521748I44449434I44774966I45249948I44636691I43424897I43390023
1053I44424699I45334537I45426089I44866090I44539276I44552346I44480888I44479728
1045I44544956I44697583I45265828I45582320I45162549I44571463I44508800I45011632
1037I45433418I45594840I45564791I45691889I45964468I45839691I45474522I45183865
1029I45291785I45976011I46531674I46126745I45234557I45334232I46395476I46552623
1021I45600459I45193453I45342782I45064035I44751268I45008395I45465605I45812573
1013I46168459I46319804I46036964I45550622I45331728I45615728I45703493I45270225
1005I45191682I45531871I45512816I45389383I45650296I46049118I46407752I46203883
997I45385291I45004853I44787975I44197926I44522114I45667520I46154839I46085519
989I45797610I45414302I45345225I45687980I46232405I46498693I46546637I46789595
981I46776891I46375871I46361091I46568014I46396087I46022795I45174459I43376769
973I41286346I39175584I36764760I34543574I32802807I31894740I31483886I30305195
965I28885255I27646832I25973736I24909255I24845737I25427540I27387934I30247845
957I32557895I32792180I30983680I29982717I30181334I30042388I30151957I30772115
949I31170387I30787628I30316371I30684289I30992658I30700840I31058802I32364836
941I33626102I34311977I35128248I36758225I38345877I39408464I40372171I41083576
933I41519653I42241746I43731678I45054568I44977736I44989706I46275829I47363091
925I47598781I47321744I46192767I45108009I44852409I44487179I44402956I44913973
917I45373198I46335317I47912708I49075520I49363429I48673950I47452750I47286076
909I47706640I46819705I45528635I45749727I47008122I47916617I48031805I47957598
901I49024400I50164126I49424199I48358985I48619837I49744355I50388883I49019819
893I46705250I45290258I45284700I46500709I47522803I48461958I49409907I49073505
885I48289115I48124517I47848884I47119279I46160092I44845080I45329896I48172400
877I48691662I45908767I44026488I44638829I45467620I45501212I46314490I49279817
869I53022204I52641217I48911350I47038110I46342585I46325728I48769533I50964823
861I49470677I46414409I45696836I47266226I49123159I49827173I48799948I47522987
853I47583390I48720306I50712460I52129772I51686977I50526852I49908465I49717177
845I48851007I48048173I49113692I51024676I51857071I51349536I50072207I48971936
837I48801109I49462798I50141406I50506880I51046480I51550535I51617595I51340008
829I50854765I50832350I51812303I52932485I53479964I53292707I52585150I52889243
821I53810686I53762070I52961434I52136185I51985696I52739731I54269056I55631768
813I55890055I56291075I57687561I57570236I55110490I53698002I53600160I52360393
805I50636421I51205093I53344987I53621964I52082561I50905091I50264534I48421709
797I46040384I45139646I45795717I47075610I47219687I47137357I49026110I51917108
789I53870235I53895214I52180343I49414732I47616981I49848000I54402689I55791785
781I54417958I54217020I53066850I49849588I49129572I51832824I53103679I50694503
773I48938406I49635031I51147804I53429882I53102824I49094637I46820743I46802298
765I45795228I45521122I48784924I51956319I51150003I50327380I52570308
758I54338865I52928454I50832900I50037456I49712657I49538959I49366361
751I48472218I47419647I47405294I47908616I48317332I49035088I49327883
744I49570779I50489779I49985542I47618814I46209380I46926464I48460492
737I49582933I50358101I51184327I52211552I53622941I54801327I54247313
730I52757871I52018677I51732050I51646178I51624741I51575820I52469962
723I55367617I59576742I61073330I58530889I56212838I55500456I55417455
716I55984905I56646289I56636273I56062348I55363708I55713670I57511298
709I57576893I55457459I54790395I55386734I55471689I56419394I59423565
702I60241974I57120416I53244579I49350542I46507305I45556790I45478553
695I45534131I46644541I49084376I51283636I52584417I54328055I57098979
688I59000069I58267838I56914471I58026957I59224643I55456054I50725163
681I49097874I49012551I49086941I48627655I47669201I48621486I52389159
674I54507616I50601974I44778080I40508980I38411349I36440450I32952991
667I29413557I25645212I23141798I23534023I23841048I21119229I17332623
660I14827681I13850966I12451670I12425041I18156711I24429325I23380663
653I20223132I18320699I18902685I21813655I27391904I37225084I46381612
646I46851036I44548315I45414363I50227339I57366061I62851598I67498449
639I73894619I76206379I73023991I66211410I60817059I60952279I64963215
632I73130445I81989108I78518322I70866934I69053792I71857025I73948243
625I75346256I77335844I74615551I70873652I71416245I71861728I69682196
618I70248303I77694173I89143710I88186905I84109275I86100635I82956418
611I75023107I71985161I75191858I83121932I86955261I79921405I74466039
604I74878297I76944229I78773434I79278465I76652167I75952978I76958032
597I72006538I65854731I63632262I60293888I48995206I32446799I21699322
590I21722775I26600918I31588936I37667636I45297281I52256931I56753171
583I58940154I60143032I61801409I65316963I71954074I78111622I77409379
576I76346302I75274798I66011694I57547272I60051541I71530700I89791536
569I97915097I88681554I81870134I78873292I77547714I78080474I83299906
562I94053491A006534101A007497625I96333492I91303149I90275985I84174198
555I74110520I61075773I49531875I50399205I61373760I70539510I75592328
548I76985638I77191157I81305737I90815096I94177168I74367158I53019028
541I39092278I28427741I14234030H91813418H69294353H53516533H46873864
534H51113221H66042400H87756371I09602875I27780526I43861402I58269181
527I66323544I65817414I64541429I60307324I35986844H93229815H55173627
520H35753278H43096847H60994651H66808590H46097414H11581333G90222148
513G77527530G78955775H07961951H46653504H70476099H79573444H87531980
506H95561058H98963989H94006448H78314255H66635441H76225298H95762546
499I07613836I14699912I19464700I23357515I28410151I33457412I36198531
492I38181157I40375775I41687366I41610045I40224491I40423230I42726501
485I43143462I40278787I37331966I35489081I34452572I34867823I35507342
478I34142921I32795172I32474222I32349750I33881885I34455076I27665155
471I10898831H89133679H77679011H84391856H99403487I13170709I24554896
464I34612406I43665839I50743669I54513785I55875702I54779951I50260014
457I44500249I39123304I34705180I35416462I42620352I50898128I56016664
450I58542005I60117930I61846543I64113719I66200356I67590307I68558105
443I69292291I69573177I68990457I67789229I66760049I65947382I64928707
436I62873036I57581474I47007328I33880602I25244070I24511655I30074819
429I39282833I48090681I51569224I47722336I42247854I43298837I49231323
422I54198148I57971134I61557841I64163923I65612506I66608277I67041423
415I66561127I65184246I62709293I58896974I54020419I48877086I43872090
408I38815485I34069264I31473931I32390549I34313809I33452281I32320495
401I35657710I40716758I42123627I38135472I28711802I15206531I02065270
394H94251665H91524044H88998398H83599343H77982494H78583231H86566747
387H94492424H99813669I08682776I22015508I35052942I45935335I54201751
380I59122159I61124206I59989916I52210636I33950656I09537830H92461305
373H91027807H97223222I02023067I08762296I20102814I31417009I37203158
366I37650107I39970418I47695402I56620393I63196857I67582245I70668134
359I72942455I74852157I76517008I76775601I71924514I62255442I57931069
352I63942830I72426491I77331691I79442819I81199222I83466825I85359975
345I86676025I87760477I88387598I88400607I87418273I84074401I77074992
338I66593008I56469720I53457366I59835396I70438125I80144635I87351212
331I91445637I92820442I92306921I90543617I87584825I77940001I54079295
324I30560001I33811099I58058227I79096522I90454080I96299900I98800750
317I96867839I87034781I65312565I33242243I00875035H77438741H68710718
310H70443546H65821796H55414142H59416954H82871082I12785080I37583963
303I54600695I66441542I75112399I80330243I77934931I56759217I11579637
296H67821034H61961595H89691663I18148161I35999853I48275373I55693454
289I61444241I69483396I76607338I79417289I79924520I81309035I83911208
282I86523581I89604096I93371402I96466453I98504657A000397502A002407611
275A004022747A004952068A003232921I92205475I69117738I52025822I58086749
268I73307685I80681120I83028304I86476858I89211809I84622796I76915829
261I79130052I90269267I99697335A004834682A008019696A010115494A011548259
254A011724217A006990150I90451637I62894290I40931682I34734129I40243913
247I56548446I78190776I94465138A003138560A007336569A009304109A008765425
240A005070249I97619310I84662923I64860791I35828354H94586419H51973772
233H32454358H43894612H68548807H91219339I14336392I39175890I58738911
226I71400549I81198611I88565572I91091462I91254166I94043291I95737947
219I90256258I86893392I94957222A006275264A013030495A017060852A021338259
212A025268820A027176445A028265661A030250118A032333397A033367646A033967283
205A036057767A039039462A040966387A043638308A046753758A048156046A050050724
198A053519433A056385207A058206104A060268617A062558207A064426011A066148212
191A067748384A069395340A071078941A070205809A066611161A066606276A071988108
184A073741823A059087299A010204908I25031161H49880539H30121649H39963074
177H41217744H43901941H38636275H02481850G51743503G00158287F43661947
170E88082469E59304227E77571353F30661891F94288709G54349341H06314506
163H49738600H85027650I10104975I18355756I09236301I03761086I23386771
156I53010661I63370738I35300541H67473883H07767304G87481640G52970872
149F66855405E65231765E05715711E16578466E73585458F38785880F95042683
142G38726469G70951738G94509266H12448724H22347804H10850078G80840192
135G67664789G85873589H23826498H62548162H83154715H97198975I12065674
128I25949917I37390659I46812559I52120428I39974021H98354336H60044930
121H63809977H72710416H46063823H13036634G83176993G50616542G57961211
114H09775948H60611892H92514868I11043702I18243683I15968445I16910104
107I28692624I42506447I51346910I56291503I60133626I64374083I68079886
100I70627824I72790805I74134034I75595871I78626304I82586791I86432823
93I89735896I91038693I90909641I92754603I96503770I98951300I98766609
86I99668629A003418163A006894567A009032446A010667187A011954043A012115038
79A011672181A012569987A013883533A014688505A015687269A014793311A011849360
72A010143406A011716705A015816444A018520857A018805712A019398570A020806965
65A022223301A021620794A011387326I92115389I85231778I98972188A014268369
58A014965787I97948383I75639295I71928422I88779457A006900980A016399590
51A014053994I91572979I62429873I60639452I88375811A013904360A024007860
44A029699465A033845743A025249154A010169363A010784513A026451726A042589401
37A052814868A054106855A051374713A053225049A058757126A061954295A061913862
30A055555926A022682282I65003463I33873640I57048531I96008999A017739765
23A030614128A044704438A055893061A060317111A063364645A068412271A070872018
16A069070053A067899118A070493473A071319943A064951624A053263771A036711272
9A021167493A010805889A011706200A027043301A039712145A046346751A059696220
2A071621778A071833709
$$ === CHEMSPECTRA INTEGRALS AND MULTIPLETS ===
##$OBSERVEDINTEGRALS= (X Y Z)

##$OBSERVEDMULTIPLETS=
##$OBSERVEDMULTIPLETSPEAKS=
$$ === CHEMSPECTRA SIMULATION ===
##$CSSIMULATIONPEAKS=
##END=


$$ === CHEMSPECTRA PEAK TABLE EDIT ===
##TITLE=RackMultipart20200902-11534-nzk5jb
##JCAMP-DX=5.00
##DATA TYPE=INFRAREDPEAKTABLE
##DATA CLASS=PEAKTABLE
##$CSCATEGORY=EDIT_PEAK
##$CSTHRESHOLD=0.93
##MAXX=3996.5625
##MAXY=1.0478872043814014
##MINX=399.65625
##MINY=0.49353858745198814
##$CSSOLVENTNAME=- - -
##$CSSOLVENTVALUE=0
##$CSSOLVENTX=0
##NPOINTS=100
##PEAKTABLE= (XY..XY)
452.671875, 0.9113869059611764
619.875, 0.8939128499725295
634.1484375, 0.7325424537913474
646.3828125, 0.8393359167309793
672.890625, 0.7491801962223169
697.359375, 0.49353858745198814
719.7890625, 0.8819994318478169
742.21875, 0.5458367461111093
762.609375, 0.8101331581149455
872.71875, 0.8124096978382616
905.34375, 0.9122266752551503
999.140625, 0.841206430373611
1025.6484375, 0.8348166334289234
1031.765625, 0.8477930413083852
1058.2734375, 0.9081530560415211
1158.1875, 0.8695727573455251
1192.8515625, 0.856841562306799
1217.3203125, 0.9098711591241
1225.4765625, 0.9090449795301904
1264.21875, 0.9195594773460126
1276.453125, 0.9022503481043715
1325.390625, 0.9121984233178319
1353.9375, 0.8565453868709212
1366.171875, 0.9098997096932475
1378.40625, 0.9119518978633377
1392.6796875, 0.917584834883456
1421.2265625, 0.8457677348825154
1443.65625, 0.7588054523804053
1457.9296875, 0.8156291831765708
1488.515625, 0.8264819966974827
1602.703125, 0.8995057332425552
1727.0859375, 0.8962084640719861
1737.28125, 0.8904547675620115
1753.59375, 0.900913475877376
2322.4921875, 0.9082905037806485
2328.609375, 0.9079152924058548
2338.8046875, 0.9076479066397719
2342.8828125, 0.9075896724571842
2357.15625, 0.9025763857472344
2660.9765625, 0.919188080846447
2681.3671875, 0.918366848196137
2689.5234375, 0.9185334427921491
2699.71875, 0.9185196149673583
2709.9140625, 0.9185847625743809
2716.03125, 0.9187176810641009
2726.2265625, 0.9183247079269252
2738.4609375, 0.9178565722813223
2748.65625, 0.918098567510488
2756.8125, 0.9184220414088575
2775.1640625, 0.9175993780583469
2783.3203125, 0.9170516716691147
2793.515625, 0.9154427634124237
2807.7890625, 0.9169042695356854
2850.609375, 0.908922074965954
2868.9609375, 0.9137010557283759
2875.078125, 0.9132685050905607
2924.015625, 0.8973950727651508
2956.640625, 0.9080991129836143
2968.875, 0.9044413551826083
2989.265625, 0.9081324328787377
3025.96875, 0.8934771402784049
3060.6328125, 0.8900475489058528
3083.0625, 0.9072607743898411
3109.5703125, 0.9164229023530289
3127.921875, 0.9188209754715624
3136.078125, 0.9185788016488519
3148.3125, 0.9193342913803232
3158.5078125, 0.9188804012537033
3164.625, 0.918699739732253
3172.78125, 0.9196624145663843
3201.328125, 0.9191706762711547
3213.5625, 0.9193806037118527
3221.71875, 0.9196901307230684
3252.3046875, 0.9188345651716265
3268.6171875, 0.9191939812648734
3284.9296875, 0.9193911534179708
3315.515625, 0.9189723710737646
3327.75, 0.9188246712844272
3346.1015625, 0.9197297082237079
3358.3359375, 0.9183755504837832
3374.6484375, 0.9191278801830242
3388.921875, 0.9191498149836449
3393.0, 0.9192213997656494
3403.1953125, 0.9196329700535917
3415.4296875, 0.9190087299869132
3427.6640625, 0.9186803091449439
3437.859375, 0.9187278140519477
3456.2109375, 0.9177518471736603
3466.40625, 0.9181845168738387
3478.640625, 0.9182554468128455
3488.8359375, 0.9196668852605312
3507.1875, 0.9198170287560776
3517.3828125, 0.9192754609099983
3537.7734375, 0.9188290814714714
3910.921875, 0.9187336549391926
3937.4296875, 0.9181746229866393
3957.8203125, 0.9185591329368163
3965.9765625, 0.9169929017058925
3976.171875, 0.9186608180505322
3984.328125, 0.9171133030327383
##END=


$$ === CHEMSPECTRA PEAK TABLE AUTO ===
##TITLE=RackMultipart20200902-11534-nzk5jb
##JCAMP-DX=5.00
##DATA TYPE=INFRAREDPEAKTABLE
##DATA CLASS=PEAKTABLE
##$CSCATEGORY=AUTO_PEAK
##$CSTHRESHOLD=0.93
##MAXX=3996.5625
##MAXY=1.0478872043814014
##MINX=399.65625
##MINY=0.49353858745198814
##NPOINTS=100
##PEAKTABLE= (XY..XY)
3507.1875, 0.9198170287560776
3346.1015625, 0.9197297082237079
3221.71875, 0.9196901307230684
3488.8359375, 0.9196668852605312
3172.78125, 0.9196624145663843
3403.1953125, 0.9196329700535917
1264.21875, 0.9195594773460126
3284.9296875, 0.9193911534179708
3213.5625, 0.9193806037118527
3148.3125, 0.9193342913803232
3517.3828125, 0.9192754609099983
3393.0, 0.9192213997656494
3268.6171875, 0.9191939812648734
2660.9765625, 0.919188080846447
3201.328125, 0.9191706762711547
3388.921875, 0.9191498149836449
3374.6484375, 0.9191278801830242
3415.4296875, 0.9190087299869132
3315.515625, 0.9189723710737646
3158.5078125, 0.9188804012537033
3252.3046875, 0.9188345651716265
3537.7734375, 0.9188290814714714
3327.75, 0.9188246712844272
3127.921875, 0.9188209754715624
3910.921875, 0.9187336549391926
3437.859375, 0.9187278140519477
2716.03125, 0.9187176810641009
3164.625, 0.918699739732253
3427.6640625, 0.9186803091449439
3976.171875, 0.9186608180505322
2709.9140625, 0.9185847625743809
3136.078125, 0.9185788016488519
3957.8203125, 0.9185591329368163
2689.5234375, 0.9185334427921491
2699.71875, 0.9185196149673583
2756.8125, 0.9184220414088575
3358.3359375, 0.9183755504837832
2681.3671875, 0.918366848196137
2726.2265625, 0.9183247079269252
3478.640625, 0.9182554468128455
3466.40625, 0.9181845168738387
3937.4296875, 0.9181746229866393
2748.65625, 0.918098567510488
2738.4609375, 0.9178565722813223
3456.2109375, 0.9177518471736603
2775.1640625, 0.9175993780583469
1392.6796875, 0.917584834883456
3984.328125, 0.9171133030327383
2783.3203125, 0.9170516716691147
3965.9765625, 0.9169929017058925
2807.7890625, 0.9169042695356854
3109.5703125, 0.9164229023530289
2793.515625, 0.9154427634124237
2868.9609375, 0.9137010557283759
2875.078125, 0.9132685050905607
905.34375, 0.9122266752551503
1325.390625, 0.9121984233178319
1378.40625, 0.9119518978633377
452.671875, 0.9113869059611764
1366.171875, 0.9098997096932475
1217.3203125, 0.9098711591241
1225.4765625, 0.9090449795301904
2850.609375, 0.908922074965954
2322.4921875, 0.9082905037806485
1058.2734375, 0.9081530560415211
2989.265625, 0.9081324328787377
2956.640625, 0.9080991129836143
2328.609375, 0.9079152924058548
2338.8046875, 0.9076479066397719
2342.8828125, 0.9075896724571842
3083.0625, 0.9072607743898411
2968.875, 0.9044413551826083
2357.15625, 0.9025763857472344
1276.453125, 0.9022503481043715
1753.59375, 0.900913475877376
1602.703125, 0.8995057332425552
2924.015625, 0.8973950727651508
1727.0859375, 0.8962084640719861
619.875, 0.8939128499725295
3025.96875, 0.8934771402784049
1737.28125, 0.8904547675620115
3060.6328125, 0.8900475489058528
719.7890625, 0.8819994318478169
1158.1875, 0.8695727573455251
1192.8515625, 0.856841562306799
1353.9375, 0.8565453868709212
1031.765625, 0.8477930413083852
1421.2265625, 0.8457677348825154
999.140625, 0.841206430373611
646.3828125, 0.8393359167309793
1025.6484375, 0.8348166334289234
1488.515625, 0.8264819966974827
1457.9296875, 0.8156291831765708
872.71875, 0.8124096978382616
762.609375, 0.8101331581149455
1443.65625, 0.7588054523804053
672.890625, 0.7491801962223169
634.1484375, 0.7325424537913474
742.21875, 0.5458367461111093
697.359375, 0.49353858745198814
##END=

##END=
`;

export default compareIr2Jcamp;
